<mat-card>
  <mat-card-content>
    <div class="row">
      <div class="col-md-4">
        <p class="text-bold">Volatility</p>
        <table class="table table-cim table-cim-small table-cim-padding">
          <thead>
            <tr>
              <th class="text-grey">Model</th>
              <th class="text-grey">YTD</th>
              <th class="text-grey">1 Yr</th>
              <th class="text-grey">5 Yr</th>
              <th class="text-grey">10 Yr</th>
              <th class="text-grey">15 Yr</th>
              <th class="text-grey">Since start</th>
            </tr>
          </thead>
          <tbody>
            @for (item of volatilityList; track item.index) {
              <tr>
                <td class="text-bold">{{ item.index }}</td>
                <td class="text-semi-bold">
                  {{ item.ytd | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["1_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["5_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item["10_yr"] | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item.since_2000 | number: "1.0-2" }}%
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="col-md-4">
        <p class="text-bold">Sharpe Ratio</p>
        <table class="table table-cim table-cim-small table-cim-padding">
          <thead>
            <tr>
              <th class="text-grey">Model</th>
              <th class="text-grey">YTD</th>
              <th class="text-grey">1 Yr</th>
              <th class="text-grey">5 Yr</th>
              <th class="text-grey">10 Yr</th>
              <th class="text-grey">Since start</th>
            </tr>
          </thead>
          <tbody>
            @for (item of sharpeList; track item.index) {
              <tr>
                <td class="text-bold">{{ item.index }}</td>
                <td class="text-semi-bold">{{ item.ytd | number: "1.0-2" }}</td>
                <td class="text-semi-bold">
                  {{ item["1_yr"] | number: "1.0-2" }}
                </td>
                <td class="text-semi-bold">
                  {{ item["5_yr"] | number: "1.0-2" }}
                </td>
                <td class="text-semi-bold">
                  {{ item["10_yr"] | number: "1.0-2" }}
                </td>
                <td class="text-semi-bold">
                  {{ item.since_2000 | number: "1.0-2" }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="col-md-4">
        <p class="text-bold">Drawdown</p>
        <table class="table table-cim table-cim-small table-cim-padding">
          <thead>
            <tr>
              <th class="text-grey">Model</th>
              <th class="text-grey">Worst</th>
              <th class="text-grey">Average</th>
              <th class="text-grey">Calmar Ratio</th>
            </tr>
          </thead>
          <tbody>
            @for (item of drawdownList; track item.index) {
              <tr>
                <td class="text-bold">{{ item.index }}</td>
                <td class="text-semi-bold">
                  {{ item.worst | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item.average | number: "1.0-2" }}%
                </td>
                <td class="text-semi-bold">
                  {{ item.calmar_ration | number: "1.0-2" }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </mat-card-content>
</mat-card>
